import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, Typography } from "@mui/material";
import { LoadService } from "../../../services/LoadService";
import { AlertContext } from "../../Dashboard/Dashboard";

export default function LoadProfilePlanningComments({ activeLoad }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [comments, setComments] = useState([]);

  useEffect(() => {
    LoadService.GetLoadComments(instance, activeLoad.id, "PC").then(res => {
      setComments(res);
    }).catch(error => {
      console.error(error);
      warning(error);
    });
  }, []);

  return (
    comments.length > 0 &&
    <Box
      backgroundColor="black_opacity.05"
      borderRadius="4px"
      margin="5px 28px 0 114px"
      padding="14px"
      display="flex"
      alignItems="end">
      <Typography variant="subhead1" color="black_opacity.100">
        Planning Comment:
      </Typography>
      <span>
        {comments.map((c, index) => (
          <Typography key={index} variant="body1" color="black_opacity.100" marginLeft="5px">
            {c.comments}
          </Typography>
        ))}
      </span>
    </Box>
  );
}

LoadProfilePlanningComments.propTypes = {
  activeLoad: PropTypes.object.isRequired
};